import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  addElement as addElementToLayoutGroup
} from '../redux/layoutGroups'

export default function * requestAddBoardToLayoutGroup (action) {
  const { layoutId, id, layoutGroupId, position } = action.payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = yield optimisticPut(addElementToLayoutGroup({
    key: `${layoutId}-${layoutGroupId}`,
    elementId: tempId,
    type: 'board',
    boardId: id,
    isBusy: true,
    position
  }))

  try {
    yield call(apiAction, 'AddBoardToLayoutGroup', {
      layoutId,
      boardId: id,
      groupId: layoutGroupId,
      position
    })
  } finally {
    yield optimisticAction.revert()
  }
}
